// Widget Scripts
import headerButton from './js/widgets/headerButton.js';
import vimeoWidget from './js/widgets/vimeoWidget.js';
import seoWdiget from './js/widgets/seoWdiget.js';
import cardWidget from './js/widgets/cardWidget.js';
import eventsWidget from './js/widgets/eventsWidget.js';
import datesWidget from './js/widgets/datesWidget.js';
import numbersWidget from './js/widgets/numbersWidget.js';
import sponsors from './js/widgets/sponsors.js';
// Custom Theme Scripts
import './js/localjs.js';
import managedPopup from './js/widgets/managedPopup.js';

// Initialize Homepage Widgets
if (globalThis.location.pathname === '/') {
  $(document).ready(function () {
    managedPopup();
    vimeoWidget();
    eventsWidget();
    seoWdiget();
    cardWidget();
    datesWidget();
    numbersWidget();
  });
}

$(document).ready(function () {
  // Initialize Custom Theme Scripts
  headerButton();
  sponsors();
});
